import React from "react"

function MemoryGameReward(props) {
    return (
        <div className="memoryGameReward">
            <h3>"Okay fine! You won this time Larry. Let me tell you what I know..."</h3>

            <h3><em>Jack hands over a tissue with a red stain on it.</em></h3>

            <h3>"An NYPD contact of mine swiped this from the crime scene. Identifying that substance will help find your thief"</h3>
        
            <button className="standardButton fourJokersButton" onClick={props.goToScience}>To The Science Lab!</button>
        </div>
    )
}

export default MemoryGameReward